export default __webpack_public_path__ + "static/media/stars-5.27f94caa.svg";